import includes from "lodash/includes"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { internal } from "../../actions/types"
import items from "./items"

const INITIAL_STATE = {}

export default function entitiesReducer(state = INITIAL_STATE, action) {
  if (includes(internal, action.type)) {
    const { model } = action

    const { name } = normalizeModel(model)

    const nextProcess = items(state[name], action)

    return nextProcess !== state[name]
      ? {
          ...state,
          [name]: nextProcess,
        }
      : state
  }
  return state
}
